<template>
  <div class="data-table-head row-flex">
    <ButtonSelectAll
      v-if="canSelectAll"
      :disabled="disabled || selectAllDisabled"
      :size="buttonAndInputSize"
      :selected-count="selectedCount"
      :total-count="totalCount"
      @click="$emit('toggle-all')"
    />
    <slot name="left-aligned" :disabled="disabled" />
    <div v-if="!searchDisabled" class="form-group has-feedback has-search m-l-10 m-b-0 m-t-0">
      <input
        ref="input"
        type="text"
        :disabled="disabled"
        :placeholder="searchPlaceholder"
        :class="`form-control input-${buttonAndInputSize} bgm-white data-table-head-input f-12 m-r-30`"
        data-test="contacts-search-input"
        @blur="blur"
        @input="$emit('search', $event.target.value)"
      />
      <span
        class="glyphicon glyphicon-search form-control-feedback f-14 m-r-0 p-t-0"
        style="color: #0e0d12"
      />
    </div>
    <slot name="right-aligned" :disabled="disabled" />
  </div>
</template>

<script>
import { nextTick } from 'vue'
import ButtonSelectAll from '@/components/ButtonSelectAll.vue'
import { SizeNames } from '@/utils/enum'

export default {
  components: { ButtonSelectAll },
  props: {
    canSelectAll: { type: Boolean, default: false },
    selectedCount: { type: Number, default: 0 },
    totalCount: { type: Number, default: 0 },
    disabled: { type: Boolean, default: false },
    selectAllDisabled: { type: Boolean, default: false },
    searchDisabled: { type: Boolean, default: false },
    searchPlaceholder: { type: String, default: $t('Search') },
  },
  emits: ['search', 'toggle-all', 'update-page-length'],
  data() {
    return {
      focusOnActive: false,
    }
  },
  computed: {
    buttonAndInputSize() {
      return SizeNames.SM
    },
  },
  watch: {
    disabled(val) {
      if (!val && this.focusOnActive) {
        // The blur event was not fired by the user so we refocus on the
        // input when we have been re-enabled so the user can continue writing
        this.focusOnActive = false
        nextTick(() => this.$refs.input.focus())
      }
    },
  },
  methods: {
    blur(event) {
      if (event.sourceCapabilities === null) {
        this.focusOnActive = true
      }
    },
  },
}
</script>

<style scoped>
.data-table-head {
  padding: 0 20px 0;
  align-items: center;
}
.data-table-head-input {
  border: 1px solid #e8e8ed;
}
.has-search {
  max-width: 200px;
}
</style>
